import { useEffect, useRef, useState } from "react";
import { subscribeToCable } from "../lib/cable";

export type MigrationProgress = {
  done: number;
  total: number;
  failed: number;
};

export default function useStorageMigration(initialProgress: MigrationProgress) {
  const [progress, setProgress] = useState<MigrationProgress>(initialProgress);
  const pollRef = useRef<ReturnType<typeof setInterval> | null>(null);
  const connectedRef = useRef(false);

  useEffect(() => {
    const unsub = subscribeToCable<MigrationProgress>({
      channel: "StorageMigrationChannel",
      onMessage: (msg) => {
        connectedRef.current = true;
        setProgress(msg);
        if (pollRef.current) {
          clearInterval(pollRef.current);
          pollRef.current = null;
        }
      },
    });

    pollRef.current = setInterval(async () => {
      if (connectedRef.current) return;
      try {
        const res = await fetch("/admin/storage", { headers: { Accept: "application/json" } });
        if (res.ok) {
          const data = await res.json();
          if (data.migration) setProgress({ done: data.migration.done, total: data.migration.total, failed: data.migration.failed_count ?? 0 });
        }
      } catch {
      }
    }, 5000);

    return () => {
      unsub();
      if (pollRef.current) clearInterval(pollRef.current);
    };
  }, []);

  return progress;
}
